import { SelectOption } from '@sdir/sds';

const DialCodeList: SelectOption[] = [
  { name: '', value: '93', secondValue: 'af' },
  { name: '', value: '376', secondValue: 'ad' },
  { name: '', value: '971', secondValue: 'ae' },
  { name: '', value: '1268', secondValue: 'ag' },
  { name: '', value: '1264', secondValue: 'ai' },
  { name: '', value: '355', secondValue: 'al' },
  { name: '', value: '244', secondValue: 'ao' },
  { name: '', value: '54', secondValue: 'ar' },
  { name: '', value: '1684', secondValue: 'as' },
  { name: '', value: '43', secondValue: 'at' },
  { name: '', value: '61', secondValue: 'au' },
  { name: '', value: '387', secondValue: 'ba' },
  { name: '', value: '1246', secondValue: 'bb' },
  { name: '', value: '880', secondValue: 'bd' },
  { name: '', value: '32', secondValue: 'be' },
  { name: '', value: '359', secondValue: 'bg' },
  { name: '', value: '973', secondValue: 'bh' },
  { name: '', value: '257', secondValue: 'bi' },
  { name: '', value: '229', secondValue: 'bj' },
  { name: '', value: '1441', secondValue: 'bm' },
  { name: '', value: '673', secondValue: 'bn' },
  { name: '', value: '591', secondValue: 'bo' },
  { name: '', value: '55', secondValue: 'br' },
  { name: '', value: '1242', secondValue: 'bs' },
  { name: '', value: '975', secondValue: 'bt' },
  { name: '', value: '267', secondValue: 'bw' },
  { name: '', value: '375', secondValue: 'by' },
  { name: '', value: '501', secondValue: 'bz' },
  { name: '', value: '1', secondValue: 'ca' },
  { name: '', value: '236', secondValue: 'cf' },
  { name: '', value: '242', secondValue: 'cg' },
  { name: '', value: '41', secondValue: 'ch' },
  { name: '', value: '225', secondValue: 'ci' },
  { name: '', value: '682', secondValue: 'ck' },
  { name: '', value: '56', secondValue: 'cl' },
  { name: '', value: '237', secondValue: 'cm' },
  { name: '', value: '86', secondValue: 'cn' },
  { name: '', value: '57', secondValue: 'co' },
  { name: '', value: '506', secondValue: 'cr' },
  { name: '', value: '53', secondValue: 'cu' },
  { name: '', value: '238', secondValue: 'cv' },
  { name: '', value: '599', secondValue: 'cb' },
  { name: '', value: '357', secondValue: 'cy' },
  { name: '', value: '420', secondValue: 'cz' },
  { name: '', value: '49', secondValue: 'de' },
  { name: '', value: '253', secondValue: 'dj' },
  { name: '', value: '45', secondValue: 'dk' },
  { name: '', value: '1767', secondValue: 'dm' },
  { name: '', value: '1', secondValue: 'do' },
  { name: '', value: '213', secondValue: 'dz' },
  { name: '', value: '593', secondValue: 'ec' },
  { name: '', value: '372', secondValue: 'ee' },
  { name: '', value: '20', secondValue: 'eg' },
  { name: '', value: '212', secondValue: 'eh' },
  { name: '', value: '34', secondValue: 'es' },
  { name: '', value: '251', secondValue: 'et' },
  { name: '', value: '358', secondValue: 'fi' },
  { name: '', value: '679', secondValue: 'fj' },
  { name: '', value: '500', secondValue: 'fk' },
  { name: '', value: '298', secondValue: 'fo' },
  { name: '', value: '33', secondValue: 'fr' },
  { name: '', value: '241', secondValue: 'ga' },
  { name: '', value: '44', secondValue: 'gb' },
  { name: '', value: '1473', secondValue: 'gd' },
  { name: '', value: '995', secondValue: 'ge' },
  { name: '', value: '594', secondValue: 'gf' },
  { name: '', value: '233', secondValue: 'gh' },
  { name: '', value: '350', secondValue: 'gi' },
  { name: '', value: '299', secondValue: 'gl' },
  { name: '', value: '220', secondValue: 'gm' },
  { name: '', value: '224', secondValue: 'gn' },
  { name: '', value: '590', secondValue: 'gp' },
  { name: '', value: '240', secondValue: 'gq' },
  { name: '', value: '30', secondValue: 'gr' },
  { name: '', value: '502', secondValue: 'gt' },
  { name: '', value: '1671', secondValue: 'gu' },
  { name: '', value: '245', secondValue: 'gw' },
  { name: '', value: '592', secondValue: 'gy' },
  { name: '', value: '852', secondValue: 'hk' },
  { name: '', value: '504', secondValue: 'hn' },
  { name: '', value: '385', secondValue: 'hr' },
  { name: '', value: '509', secondValue: 'ht' },
  { name: '', value: '36', secondValue: 'hu' },
  { name: '', value: '62', secondValue: 'id' },
  { name: '', value: '353', secondValue: 'ie' },
  { name: '', value: '972', secondValue: 'il' },
  { name: '', value: '91', secondValue: 'in' },
  { name: '', value: '964', secondValue: 'iq' },
  { name: '', value: '98', secondValue: 'ir' },
  { name: '', value: '354', secondValue: 'is' },
  { name: '', value: '39', secondValue: 'it' },
  { name: '', value: '1', secondValue: 'jm' },
  { name: '', value: '962', secondValue: 'jo' },
  { name: '', value: '81', secondValue: 'jp' },
  { name: '', value: '254', secondValue: 'ke' },
  { name: '', value: '855', secondValue: 'kh' },
  { name: '', value: '269', secondValue: 'km' },
  { name: '', value: '1869', secondValue: 'kn' },
  { name: '', value: '82', secondValue: 'kr' },
  { name: '', value: '965', secondValue: 'kw' },
  { name: '', value: '1345', secondValue: 'ky' },
  { name: '', value: '7', secondValue: 'kz' },
  { name: '', value: '856', secondValue: 'la' },
  { name: '', value: '961', secondValue: 'lb' },
  { name: '', value: '1758', secondValue: 'lc' },
  { name: '', value: '423', secondValue: 'li' },
  { name: '', value: '94', secondValue: 'lk' },
  { name: '', value: '231', secondValue: 'lr' },
  { name: '', value: '266', secondValue: 'ls' },
  { name: '', value: '370', secondValue: 'lt' },
  { name: '', value: '352', secondValue: 'lu' },
  { name: '', value: '371', secondValue: 'lv' },
  { name: '', value: '218', secondValue: 'ly' },
  { name: '', value: '212', secondValue: 'ma' },
  { name: '', value: '377', secondValue: 'mc' },
  { name: '', value: '373', secondValue: 'md' },
  { name: '', value: '382', secondValue: 'me' },
  { name: '', value: '261', secondValue: 'mg' },
  { name: '', value: '223', secondValue: 'ml' },
  { name: '', value: '976', secondValue: 'mn' },
  { name: '', value: '596', secondValue: 'mq' },
  { name: '', value: '222', secondValue: 'mr' },
  { name: '', value: '1664', secondValue: 'ms' },
  { name: '', value: '356', secondValue: 'mt' },
  { name: '', value: '230', secondValue: 'mu' },
  { name: '', value: '265', secondValue: 'mw' },
  { name: '', value: '52', secondValue: 'mx' },
  { name: '', value: '60', secondValue: 'my' },
  { name: '', value: '258', secondValue: 'mz' },
  { name: '', value: '264', secondValue: 'na' },
  { name: '', value: '687', secondValue: 'nc' },
  { name: '', value: '227', secondValue: 'ne' },
  { name: '', value: '234', secondValue: 'ng' },
  { name: '', value: '505', secondValue: 'ni' },
  { name: '', value: '31', secondValue: 'nl' },
  { name: '', value: '47', secondValue: 'no' },
  { name: '', value: '977', secondValue: 'np' },
  { name: '', value: '64', secondValue: 'nz' },
  { name: '', value: '968', secondValue: 'om' },
  { name: '', value: '507', secondValue: 'pa' },
  { name: '', value: '51', secondValue: 'pe' },
  { name: '', value: '689', secondValue: 'pf' },
  { name: '', value: '675', secondValue: 'pg' },
  { name: '', value: '63', secondValue: 'ph' },
  { name: '', value: '92', secondValue: 'pk' },
  { name: '', value: '48', secondValue: 'pl' },
  { name: '', value: '508', secondValue: 'pm' },
  { name: '', value: '1', secondValue: 'pr' },
  { name: '', value: '351', secondValue: 'pt' },
  { name: '', value: '595', secondValue: 'py' },
  { name: '', value: '974', secondValue: 'qa' },
  { name: '', value: '40', secondValue: 'ro' },
  { name: '', value: '381', secondValue: 'rs' },
  { name: '', value: '7', secondValue: 'ru' },
  { name: '', value: '250', secondValue: 'rw' },
  { name: '', value: '966', secondValue: 'sa' },
  { name: '', value: '248', secondValue: 'sc' },
  { name: '', value: '249', secondValue: 'sd' },
  { name: '', value: '46', secondValue: 'se' },
  { name: '', value: '65', secondValue: 'sg' },
  { name: '', value: '290', secondValue: 'sh' },
  { name: '', value: '386', secondValue: 'si' },
  { name: '', value: '421', secondValue: 'sk' },
  { name: '', value: '232', secondValue: 'sl' },
  { name: '', value: '378', secondValue: 'sm' },
  { name: '', value: '221', secondValue: 'sn' },
  { name: '', value: '252', secondValue: 'so' },
  { name: '', value: '597', secondValue: 'sr' },
  { name: '', value: '239', secondValue: 'st' },
  { name: '', value: '503', secondValue: 'sv' },
  { name: '', value: '963', secondValue: 'sy' },
  { name: '', value: '268', secondValue: 'sz' },
  { name: '', value: '1649', secondValue: 'tc' },
  { name: '', value: '235', secondValue: 'td' },
  { name: '', value: '228', secondValue: 'tg' },
  { name: '', value: '66', secondValue: 'th' },
  { name: '', value: '216', secondValue: 'tn' },
  { name: '', value: '676', secondValue: 'to' },
  { name: '', value: '90', secondValue: 'tr' },
  { name: '', value: '1868', secondValue: 'tt' },
  { name: '', value: '688', secondValue: 'tv' },
  { name: '', value: '886', secondValue: 'tw' },
  { name: '', value: '255', secondValue: 'tz' },
  { name: '', value: '380', secondValue: 'ua' },
  { name: '', value: '256', secondValue: 'ug' },
  { name: '', value: '1', secondValue: 'us' },
  { name: '', value: '598', secondValue: 'uy' },
  { name: '', value: '39', secondValue: 'va' },
  { name: '', value: '1784', secondValue: 'vc' },
  { name: '', value: '58', secondValue: 've' },
  { name: '', value: '1284', secondValue: 'vg' },
  { name: '', value: '1340', secondValue: 'vi' },
  { name: '', value: '84', secondValue: 'vn' },
  { name: '', value: '678', secondValue: 'vu' },
  { name: '', value: '685', secondValue: 'ws' },
  { name: '', value: '967', secondValue: 'ye' },
  { name: '', value: '27', secondValue: 'za' },
  { name: '', value: '260', secondValue: 'zm' },
  { name: '', value: '263', secondValue: 'zw' },
];

export default DialCodeList;
